module.exports = __webpack_public_path__ + "img/chalk_5.e0a5bc7d.png";